<template>
  <div style="width: 100%;">
    <v-textarea v-bind="{ ...$attrs, ...commonAttrs }" v-on="$listeners">
      <template v-for="(_, scopedSlotName) in $scopedSlots" #[scopedSlotName]="slotData">
        <slot :name="scopedSlotName" v-bind="slotData" />
      </template>
      <template v-for="(_, slotName) in $slots" #[slotName]>
        <slot :name="slotName" />
      </template>
    </v-textarea>
  </div>
</template>

<script>
export default {
  name: 'Textarea',
  inheritAttrs: false,
  computed: {
    commonAttrs() {
      return {
        prependInnerIcon: this.$attrs.prependInnerIcon || 'mdi-chat-outline',
        outlined: true,
        hideDetails: this.$attrs.hideDetails || 'auto',
        rows: this.$attrs.rows || "3",
      }
    }
  }
};
</script>